/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import './AssistantCardStyles.scss';
const BASE_CLASS = 'ai-chat-assistant-card';
export function AssistantCard({ agent, onClick }) {
    const handleClick = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick(agent.name);
    };
    return (React.createElement("button", { type: "button", className: BASE_CLASS, onClick: handleClick, "aria-label": agent.display_name },
        React.createElement("div", { className: `${BASE_CLASS}__icon` },
            React.createElement("i", { className: agent.icon })),
        React.createElement(Text, { variant: "x-small", as: "span", className: `${BASE_CLASS}__name` }, agent.display_name),
        React.createElement(Text, { variant: "body", as: "span", className: `${BASE_CLASS}__description` }, agent.short_description)));
}
